import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../components/Footer';

const Contact = () => {
  const [status, setStatus] = React.useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const data = {
      name: form.name.value,
      email: form.email.value,
      mobile: form.mobile.value,
      company: form.company.value,
      message: form.message.value,
    };
    try {
      // replace '/api/contact' with your real endpoint
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
      if (res.ok) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
      }
    } catch (err) {
      setStatus('error');
    }
  };

  return (
    <section id="contact" className="py-20 px-6 bg-gray-900 text-gray-100">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-4xl mx-auto text-center mb-12"
      >
        <h2 className="text-3xl font-bold">Contact Us</h2>
        <p className="mt-2 text-gray-300">
          Reach out to Munorva Technologies Pvt Ltd at our Allahabad office or via phone/email.
        </p>
      </motion.div>
      <form onSubmit={handleSubmit} className="max-w-3xl mx-auto grid grid-cols-1 gap-6">
        <input
          name="name"
          type="text"
          placeholder="Name"
          className="w-full px-4 py-3 rounded-md bg-gray-800 border border-gray-700 focus:outline-none"
          required
        />
        <input
          name="email"
          type="email"
          placeholder="Email"
          className="w-full px-4 py-3 rounded-md bg-gray-800 border border-gray-700 focus:outline-none"
          required
        />
        <input
          name="mobile"
          type="tel"
          placeholder="Mobile Number"
          className="w-full px-4 py-3 rounded-md bg-gray-800 border border-gray-700 focus:outline-none"
        />
        <input
          name="company"
          type="text"
          placeholder="Company"
          className="w-full px-4 py-3 rounded-md bg-gray-800 border border-gray-700 focus:outline-none"
        />
        <textarea
          name="message"
          rows="4"
          placeholder="Message"
          className="w-full px-4 py-3 rounded-md bg-gray-800 border border-gray-700 focus:outline-none"
          required
        ></textarea>
        <button
          type="submit"
          className="w-full py-3 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-md text-white font-medium hover:opacity-90 transition"
        >
          Send Message
        </button>
      </form>
      {status === 'success' && <p className="mt-4 text-green-400 text-center">Message sent successfully!</p>}
      {status === 'error' && <p className="mt-4 text-red-400 text-center">Failed to send message. Please try again later.</p>}
      <Footer />
    </section>
  );
};

export default Contact;
